module.exports = __webpack_public_path__ + "static/img/chuangzao.e3b13ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultrue/chuangzao.png
// module id = R9sD
// module chunks = 1